// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

export const getRouteGuards = (
  isCustomTokenLogin,
  { currentUser, customTokenVerified, patientConsent, registered }
) => {
  const isEmailVerified = currentUser?.emailVerified;

  const loginGuards = [
    {
      route: "/user/email-verification",
      conditions: !isEmailVerified,
    },
    {
      route: "/user/registration",
      conditions: isEmailVerified && !registered,
    },
    {
      route: "/user/agreements",
      conditions: registered && !patientConsent,
    },
  ];

  const tokenLoginGuards = [
    {
      route: "/user/birthdate",
      conditions: customTokenVerified === "undefined",
    },
    {
      route: "/user/agreements",
      conditions:
        registered && !patientConsent && customTokenVerified === "true",
    },
  ];

  return isCustomTokenLogin ? tokenLoginGuards : loginGuards;
};
